import { GET_MONTHLY_PROGRESS } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_MONTHLY_PROGRESS.LOAD:
      return {
        ...state,
        loading: true
      };
    case GET_MONTHLY_PROGRESS.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case GET_MONTHLY_PROGRESS.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
